import { IController, IOnChangesObject } from 'angular';
import { FontStyleService, IFontStyleModel } from '../../tn.common';
import { LocalFavorites } from '../local-favorites.service/localFavorites';
import template from './save-favorite-button.html';
import { SaveFavoritePopoverController } from './save-favorite-popover';

export class SaveFavoriteListButtonController implements IController {
    // bindings
    // list of style ids to add to list, will be overridden by styles
    styleIds?: number[];
    // list of style models to add to list, takes precedence over styleIds
    styles?: IFontStyleModel[];

    // locals
    popoverController?: SaveFavoritePopoverController;
    isFavorite = false;
    selectedStyles: IFontStyleModel[] = [];

    static $inject = ['localFavorites', 'FontStyleService'];
    constructor(
        protected localFavorites: LocalFavorites,
        protected styleService: FontStyleService
    ) {}

    $onInit(): void {
        // update when favorites change
        this.localFavorites.favorites$.subscribe(() => {
            this._updateIsFavorite();
        });
    }

    $onChanges(changes: IOnChangesObject): void {
        // console.log('changes', changes);
        const styles = changes.styles;
        if (styles && styles.currentValue !== styles.previousValue) {
            // update when styles change
            this._updateIsFavorite();
        }

        const styleIds = changes.styleIds;
        if (
            !this.styles &&
            styleIds &&
            styleIds.currentValue !== styleIds.previousValue
        ) {
            // give styles priority
            this._updateIsFavorite();
        }
    }

    _updateIsFavorite(): void {
        const styleIds =
            this.styles?.map((style) => style.id) || this.styleIds || [];
        this.isFavorite =
            styleIds.length > 0 &&
            styleIds.every((style) => {
                return this.localFavorites.isFavoriteStyle(style);
            });
        // console.log('isFavorite', this.isFavorite, styleIds);
    }

    clicked($event: Event): void {
        $event.preventDefault();

        if (this.styles) {
            this.selectedStyles = this.styles;

            if (this.popoverController == undefined) {
                throw new Error('No popover controller');
            }
            this.popoverController.show($event.currentTarget);
        }

        if (this.styleIds) {
            // load styles, by the time someone is clicking this button,
            // they're likely already inflight or loaded.
            this.styleService
                .list({
                    id: this.styleIds,
                    page_size: this.styleIds.length + 10,
                })
                .then(({ results: styles }) => {
                    this.selectedStyles = styles;
                    if (this.popoverController == undefined) {
                        throw new Error('No popover controller');
                    }
                    this.popoverController.show($event.currentTarget);
                });
        }
    }
}

export const SaveFavoriteListButtonComponent = {
    bindings: {
        // you can pass a list of just style ids if you don't have the full style model.
        // styles will take precedence if both are passed.
        styleIds: '<?',
        // you can pass a list of style models if you have them
        styles: '<?',
    },
    controller: SaveFavoriteListButtonController,
    template,
};
